"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXBtcProvider = void 0;
const _1 = require("./");
const core_1 = require("@okxconnect/core");
class OKXBtcProvider {
    constructor(provider) {
        this.caip = [
            "btc:mainnet",
            "fractal:mainnet"
        ];
        this.provider = provider;
    }
    getAddressForChainId(chainId) {
        var _a, _b;
        let ns = this.checkChainId(chainId);
        if (ns == undefined) {
            throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
        }
        let accounts = (_b = (_a = this.provider.session) === null || _a === void 0 ? void 0 : _a.namespaces['btc']) === null || _b === void 0 ? void 0 : _b.accounts.filter(function (account) {
            return account.startsWith(chainId);
        });
        if (accounts == undefined || accounts.length < 0) {
            throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `no connected account`);
        }
        let account = accounts[0];
        const address = account.split(':')[2];
        return address;
    }
    getAccount(chainId) {
        var _a, _b, _c;
        let ns = this.checkChainId(chainId);
        if (ns == undefined) {
            throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
        }
        let extra = (_c = (_b = (_a = this.provider.session) === null || _a === void 0 ? void 0 : _a.namespaces['btc']) === null || _b === void 0 ? void 0 : _b.extra) === null || _c === void 0 ? void 0 : _c[chainId];
        let publicKey = "";
        if (extra != undefined) {
            publicKey = extra["compressedPublicKey"];
        }
        return {
            address: this.getAddressForChainId(chainId),
            publicKey: publicKey
        };
    }
    /**
     *
     * @param signStr
     * @param chainId
     * @param type
     * @returns
     */
    signMessage(chainId, signStr, type) {
        return __awaiter(this, void 0, void 0, function* () {
            let ns = this.checkChainId(chainId);
            if (ns == undefined) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
            }
            if (signStr === 'undefined') {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signMessage parmas error`);
            }
            let params = {
                signStr: signStr,
                from: this.getAddressForChainId(chainId)
            };
            if (type) {
                params.type = type;
            }
            try {
                const ret = yield this.provider.request({
                    method: "btc_signMessage",
                    params: params
                }, chainId);
                if ('result' in ret) {
                    return ret.result;
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                if (error instanceof _1.OKXConnectError) {
                    throw error;
                }
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    /**
     *
     * @param chainId
     * @param toAddress
     * @param satoshis
     * @param options { feeRate: 0 }
     * @returns
     */
    sendBitcoin(chainId, toAddress, satoshis, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let ns = this.checkChainId(chainId);
            if (ns == undefined) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
            }
            let params = {
                from: this.getAddressForChainId(chainId),
                to: toAddress,
                value: (satoshis / 100000000).toString(),
            };
            if (options === null || options === void 0 ? void 0 : options.feeRate) {
                params["satBytes"] = options.feeRate.toString();
            }
            let result = yield this.send(chainId, params);
            if (result !== undefined && ('txhash' in result)) {
                // return txhash directly
                return result.txhash;
            }
            // or return unexpected result
            return result;
        });
    }
    //  from - string：当前连接的钱包的 BTC 地址
    //  to - string：接受 BTC 的地址
    //  value - string：发送 BTC 的数量
    //  satBytes - string： (可选) 自定义费率
    //  memo - string： (可选) 指定 outputs OP_RETURN 内容 示例
    //  memoPos - number： (可选) 指定 outputs OP_RETURN 输出位置，如果传了 memo 则必须传入 memoPos 指定位置，否则 memo 不生效
    send(chainId, input) {
        return __awaiter(this, void 0, void 0, function* () {
            let ns = this.checkChainId(chainId);
            if (ns == undefined) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
            }
            if (!this.checkParameters(input, 'to', 'value')) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method send parmas  error`);
            }
            input["from"] = this.getAddressForChainId(chainId);
            try {
                const ret = yield this.provider.request({
                    method: 'btc_send',
                    params: input
                }, chainId);
                if ('result' in ret) {
                    return {
                        txhash: ret.result
                    };
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                if (error instanceof _1.OKXConnectError) {
                    throw error;
                }
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method send request error: ${error}`);
            }
        });
    }
    /**
     *
     * @param psbtHex string 要签名的 psbt 的十六进制字符串
     * @param options object { autoFinalized: 0 }
     */
    signPsbt(chainId, psbtHex, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.signPsbts(chainId, [psbtHex], [options]).then(psbtResults => {
                    let results = JSON.parse(psbtResults);
                    resolve(results[0]);
                }).catch(error => {
                    reject(error);
                });
            });
        });
    }
    /**
     *
     * @param chainId
     * @param psbtHexs Array
     * @param options Array [{ autoFinalized: 0 }]
     * @returns
     */
    signPsbts(chainId, psbtHexs, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let ns = this.checkChainId(chainId);
            if (ns == undefined) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
            }
            if (psbtHexs === undefined) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signPsbts params error`);
            }
            let params = {
                psbtHexs: psbtHexs,
                options: options
            };
            params.from = this.getAddressForChainId(chainId);
            try {
                const ret = yield this.provider.request({
                    method: "btc_signPsbts",
                    params: params
                }, chainId);
                if ('result' in ret) {
                    return ret.result;
                }
            }
            catch (error) {
                if (error instanceof _1.OKXConnectError) {
                    throw error;
                }
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method send request error: ${error}`);
            }
        });
    }
    /**
     *
     * @param chainId
     * @param psbtHex string
     * @param options object
     * @returns
     */
    signAndPushPsbt(chainId, psbtHex, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let ns = this.checkChainId(chainId);
            if (ns == undefined) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
            }
            if (psbtHex === undefined) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signPsbts params error`);
            }
            let params = {
                psbtHex: psbtHex,
                options: options
            };
            params.from = this.getAddressForChainId(chainId);
            try {
                const ret = yield this.provider.request({
                    method: "btc_signAndPushPsbt",
                    params: params
                }, chainId);
                if ('result' in ret) {
                    return JSON.parse(ret.result);
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                if (error instanceof _1.OKXConnectError) {
                    throw error;
                }
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method send request error: ${error}`);
            }
        });
    }
    /**
     *
     * @param address string, receiver address
     * @param inscriptionId string, 铭文 ID + 协议，没有传协议则默认是 Ordinals NFT ，目前仅支持 Ordinals 及 Atomicals 协议
     * @param options object, { feeRate: number } custom rates
     */
    sendInscription(chainId, address, inscriptionId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            let extension = {
                address: address,
                inscriptionId: inscriptionId,
                options: options
            };
            let ns = this.checkChainId(chainId);
            if (ns == undefined) {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
            }
            if (address === 'undefined') {
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method sendInscription params error`);
            }
            var feeRate = 0;
            if (options && ('feeRate' in options)) {
                feeRate = options.feeRate;
            }
            let coinId = '';
            let from = this.getAddressForChainId(chainId);
            var protocolId = 7; //ProtocolIdBRCNFT
            if (inscriptionId !== 'undefined') {
                let atomicSuffix = "-Atomicals";
                let ordinalsSuffix = "-Ordinals";
                if (inscriptionId === null || inscriptionId === void 0 ? void 0 : inscriptionId.toLowerCase().endsWith(atomicSuffix.toLowerCase())) {
                    protocolId = 8; //WXRCProtocolIdARCNFT
                    inscriptionId = this.removeSuffix(inscriptionId, atomicSuffix);
                }
                else if (inscriptionId === null || inscriptionId === void 0 ? void 0 : inscriptionId.toLowerCase().endsWith(ordinalsSuffix.toLowerCase())) {
                    inscriptionId = this.removeSuffix(inscriptionId, ordinalsSuffix);
                }
            }
            let params = {
                scenario: 5,
                feeRate: feeRate,
                txType: "20",
                to: address,
                batchBean: [
                    {
                        coinAmount: "1",
                        nftId: inscriptionId,
                        protocolId: protocolId,
                        coinId: coinId,
                        inscriptionId: "",
                        from: from
                    }
                ],
                extension: extension,
            };
            try {
                const ret = yield this.provider.request({
                    method: "btc_sendInscription",
                    params: params,
                    injectParams: {
                        address: address,
                        inscriptionId: inscriptionId,
                        options: options
                    }
                }, chainId);
                if ('result' in ret) {
                    return ret.result;
                }
                else {
                    let errorData = ret;
                    return errorData.error;
                }
            }
            catch (error) {
                if (error instanceof _1.OKXConnectError) {
                    throw error;
                }
                throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `the method signTransaction request error`);
            }
        });
    }
    sendRunes(chainId, address, runeid, amount, options) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!chainId || !address || !runeid || !amount) {
                    throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `The parameter is empty. Please check`);
                }
                let ns = this.checkChainId(chainId);
                let protocolId = undefined;
                if (ns != undefined) {
                    if (ns.startsWith("btc")) {
                        protocolId = 13;
                    }
                    else if (ns.startsWith("fractal")) {
                        protocolId = 16;
                    }
                }
                if (ns == undefined || protocolId == undefined) {
                    throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
                }
                let fromAddress = this.getAddressForChainId(chainId); // string
                let params = {
                    fromAddress: fromAddress,
                    protocolId: protocolId,
                    address: address, //String
                    runeid: runeid, //String
                    amount: amount, // String
                    options: options
                };
                (0, core_1.logDebug)("OKXBtcProvider sendRunes -->", JSON.stringify(params));
                const ret = yield this.provider.request({
                    method: "btc_sendRunes",
                    params: params,
                    injectParams: {
                        address: address,
                        runeid: runeid,
                        amount: amount,
                        options: options
                    }
                }, chainId);
                return ret.result;
            }
            catch (err) {
                throw err;
            }
        });
    }
    inscribeTransfer(chainId, ticker, amount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!chainId || !ticker || !amount) {
                    throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `The parameter is empty. Please check`);
                }
                let ns = this.checkChainId(chainId);
                let protocolId = undefined;
                if (ns != undefined) {
                    if (ns.startsWith("btc")) {
                        protocolId = 1;
                    }
                    else if (ns.startsWith("fractal")) {
                        protocolId = 14;
                    }
                }
                if (ns == undefined || protocolId == undefined) {
                    throw new _1.OKXConnectError(_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `invalid chainId`);
                }
                let fromAddress = this.getAddressForChainId(chainId); // string
                let params = {
                    fromAddress: fromAddress,
                    protocolId: protocolId,
                    ticker: ticker, //String
                    amount: amount, // String
                };
                (0, core_1.logDebug)("OKXBtcProvider inscribeTransfer -->", JSON.stringify(params));
                const ret = yield this.provider.request({
                    method: "btc_inscribeTransfer",
                    params: params
                }, chainId);
            }
            catch (err) {
                throw err;
            }
        });
    }
    removeSuffix(str, suffix) {
        if (str.endsWith(suffix)) {
            return str.slice(0, str.length - suffix.length);
        }
        return str;
    }
    checkParameters(params, ...keys) {
        var unexistKeys = [];
        keys.forEach(key => {
            if (!(`${key}` in params)) {
                unexistKeys.push(key);
            }
        });
        if (unexistKeys.length > 0) {
            console.log('not find key: ', unexistKeys.join(","));
            return false;
        }
        return true;
    }
    /**
     *
     * @param chainId eg. btc:mainnet
     * @returns eg. btc
     */
    checkChainId(chainId) {
        if (this.caip.includes(chainId)) {
            let [namespaceKey, _] = chainId.split(":");
            return namespaceKey;
        }
        return undefined;
    }
}
exports.OKXBtcProvider = OKXBtcProvider;
exports.default = OKXBtcProvider;
